import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";

const LangContext = createContext(null);

export const TRANSLATIONS = {
  es: {
    nav: {
      home: "Inicio",
      camara: "La Cámara",
      camaraOverview: "La Cámara",
      mision: "Misión y Objetivos",
      contacto: "Contacto",
      servicios: "Servicios",
      informacion: "Información",
      anuario: "Anuario",
      newsletters: "Newsletters",
      noticias: "Noticias Socios",
      invertir: "Invertir en Marruecos",
      actividades: "Actividades",
      proximas: "Próximas Actividades",
      eventos: "Eventos",
      calendario: "Calendario",
      eventosCamara: "Eventos Cámara",
      eventosSocios: "Eventos Socios",
      feriasEs: "Ferias España",
      feriasMa: "Ferias Marruecos",
      socios: "Socios",
      ventajas: "Ventajas del Socio",
      sociosStandard: "Socios Standard",
      sociosPremium: "Socios Premium",
      buscador: "Buscador de Socios",
      becomeMember: "Hágase Socio",
      admin: "CMS",
    },
    hero: {
      since: "Desde 1886",
      learnMore: "Saber más",
    },
    header: {
      topbar: "CÁMARA OFICIAL DE COMERCIO DE ESPAÑA EN TÁNGER · DESDE 1886",
    },
    activityCategories: {
      all: "Todas",
      proximas: "Próximas actividades",
      encuentros: "Encuentros empresariales",
      networking: "Networking",
      seminarios: "Seminarios",
      salones_ferias: "Salones, ferias y foros",
      visitas_reuniones: "Visitas y reuniones",
      actos_institucionales: "Actos institucionales",
      webinars: "Webinars",
    },
    home: {
      welcomeKicker: "Bienvenido a la CECIT",
      welcomeTitle: "Una institución centenaria al servicio del comercio bilateral",
      welcomeBody: "La Cámara Oficial de Comercio de España en Tánger ha sido, desde 1886, un puente entre las economías española y marroquí — promoviendo la inversión, el comercio y la cooperación entre ambas orillas del Estrecho.",
      manifestoKicker: "Desde 1886",
      manifestoTitle: "Juntos creamos futuro",
      manifestoBody: "Acompañamos a las empresas españolas y marroquíes en cada etapa de sus proyectos de inversión y comercialización.",
      statsTitle: "Nuestra trayectoria en cifras",
      stats: { years: "Años de historia", members: "Socios activos", activities: "Actividades organizadas", companies: "Empresas conectadas" },
      servicesKicker: "Nuestros servicios",
      servicesTitle: "Soluciones integrales para su empresa",
      servicesBody: "Una propuesta de valor diseñada para acompañar a las empresas en su desarrollo entre España y Marruecos.",
      seeAll: "Ver todo",
      partnersTitle: "Nuestros socios",
      partnersSubtitle: "Empresas que forman parte de nuestra red",
      benefitsKicker: "Ventajas del socio",
      benefitsTitle: "Ser socio de la CECIT",
      newsKicker: "Actualidad",
      newsTitle: "Últimas noticias y eventos",
      activitiesKicker: "Actualidad",
      activitiesTitle: "Últimas actividades",
      newsletterTitle: "Suscríbase a nuestra Newsletter",
      newsletterBody: "Reciba mensualmente información sobre eventos, oportunidades de negocio y novedades.",
      newsletterCta: "Suscribirse",
      newsletter: {
        namePlaceholder: "Nombre (opcional)",
        confirmSoon: "Casi listo — revise su correo para confirmar la suscripción.",
        subscribed: "¡Gracias! Ya está suscrito.",
        pending: "Hemos recibido su correo. Le confirmaremos pronto.",
        failed: "No hemos podido completar la suscripción.",
      },
      ctaJoinTitle: "¿Quiere unirse a la CECIT?",
      ctaJoinBody: "Acceda a una red privilegiada de empresas españolas y marroquíes.",
      ctaJoinBtn: "Hágase Socio",
      ctaDirTitle: "Buscador de Socios",
      ctaDirBody: "Encuentre empresas, sectores y contactos en nuestra red.",
      ctaDirBtn: "Explorar directorio",
    },
    services: {
      info: "Información Empresarial",
      infoDesc: "Estudios sectoriales e informes de mercado.",
      training: "Plataforma de Formación",
      trainingDesc: "Cursos y desarrollo profesional.",
      visa: "Gestión de Visados",
      visaDesc: "Tramitación profesional para empresas.",
      jobs: "Bolsa de Empleo",
      jobsDesc: "Conectamos talento y oportunidades.",
      opportunities: "Oportunidades de Negocio",
      opportunitiesDesc: "Licitaciones y alianzas bilaterales.",
      arbitration: "Arbitraje y Mediación",
      arbitrationDesc: "Resolución de conflictos comerciales.",
      networking: "Networking",
      networkingDesc: "Eventos exclusivos para socios.",
      promotion: "Promoción Internacional",
      promotionDesc: "Visibilidad en España y Marruecos.",
    },
    benefits: {
      one: "Acceso preferente a eventos y misiones comerciales",
      two: "Información de mercado y estudios sectoriales",
      three: "Promoción de su empresa en nuestra red",
      four: "Asesoramiento institucional",
      five: "Tarifas reducidas en servicios",
    },
    contact: {
      title: "Contacto",
      subtitle: "Estamos a su disposición",
      address: "Dirección",
      phone: "Teléfono",
      email: "Email",
      hours: "Horario",
      formTitle: "Envíenos un mensaje",
      name: "Nombre completo",
      company: "Empresa",
      subject: "Asunto",
      message: "Mensaje",
      consent: "He leído y acepto la política de privacidad.",
      send: "Enviar mensaje",
      sending: "Enviando...",
      success: "Mensaje enviado. Le responderemos en breve.",
      error: "Error al enviar el mensaje.",
    },
    members: {
      title: "Buscador de Socios",
      subtitle: "Encuentre empresas en nuestra red",
      search: "Buscar por nombre o sector...",
      tier: "Categoría",
      all: "Todas",
      basico: "Básico",
      standard: "Standard",
      premium: "Premium",
      visit: "Visitar web",
      noResults: "No se encontraron socios.",
    },
    footer: {
      partnersTitle: "CON EL APOYO Y RECONOCIMIENTO DE :",
      about: "Cámara Oficial de Comercio de España en Tánger. Desde 1886 al servicio de las empresas españolas y marroquíes.",
      contact: "Contacto",
      legal: "Legal",
      navigation: "Navegación",
      social: "Síganos",
      rights: "Todos los derechos reservados.",
      poweredByPrefix: "Diseñado y desarrollado por",
      webAgencyTangier: "Agencia Web en Tánger",
      privacy: "Política de Privacidad",
      cookies: "Política de Cookies",
      legalNotice: "Aviso Legal",
      managePrefs: "Preferencias de cookies",
    },
    cookies: {
      title: "Respetamos su privacidad",
      body: "Utilizamos cookies para asegurar el funcionamiento del sitio, medir su uso y ofrecerle una mejor experiencia. Puede aceptarlas todas, rechazar las no esenciales o personalizarlas.",
      acceptAll: "Aceptar todas",
      rejectAll: "Rechazar no esenciales",
      customize: "Personalizar",
      savePrefs: "Guardar preferencias",
      policyLink: "Ver la Política de Cookies",
      catNecessary: "Necesarias",
      catNecessaryDesc: "Imprescindibles para el funcionamiento del sitio (sesión, seguridad, formularios).",
      catAnalytics: "Analíticas",
      catAnalyticsDesc: "Nos permiten medir el uso del sitio de forma anónima para mejorarlo.",
      catMarketing: "Marketing",
      catMarketingDesc: "Se utilizan para mostrar contenido y publicidad relevantes.",
      catFunctional: "Funcionales",
      catFunctionalDesc: "Habilitan funciones avanzadas como mapas interactivos o vídeos incrustados.",
      alwaysOn: "Siempre activas",
    },
    common: {
      readMore: "Leer más",
      back: "Volver",
      loading: "Cargando...",
      sending: "Enviando…",
      filterAll: "Todos",
      upcoming: "Próximas",
      past: "Pasadas",
      noContent: "No hay contenido disponible.",
    },
    cms: {
      login: "Iniciar sesión",
      email: "Correo electrónico",
      password: "Contraseña",
      logout: "Cerrar sesión",
      dashboard: "Panel",
      heroSlides: "Hero / Portada",
      pages: "Páginas",
      members: "Socios",
      news: "Noticias",
      events: "Eventos",
      settings: "Ajustes",
      users: "Usuarios",
      submissions: "Mensajes",
      add: "Añadir",
      edit: "Editar",
      delete: "Eliminar",
      save: "Guardar",
      cancel: "Cancelar",
      confirm: "Confirmar",
    },
  },
  fr: {
    nav: {
      home: "Accueil",
      camara: "La Chambre",
      camaraOverview: "La Chambre",
      mision: "Mission et Objectifs",
      contacto: "Contact",
      servicios: "Services",
      informacion: "Information",
      anuario: "Annuaire",
      newsletters: "Newsletters",
      noticias: "Actualités Membres",
      invertir: "Investir au Maroc",
      actividades: "Activités",
      proximas: "Prochaines Activités",
      eventos: "Événements",
      calendario: "Calendrier",
      eventosCamara: "Événements Chambre",
      eventosSocios: "Événements Membres",
      feriasEs: "Salons Espagne",
      feriasMa: "Salons Maroc",
      socios: "Membres",
      ventajas: "Avantages du Membre",
      sociosStandard: "Membres Standard",
      sociosPremium: "Membres Premium",
      buscador: "Annuaire des Membres",
      becomeMember: "Devenir Membre",
      admin: "CMS",
    },
    hero: {
      since: "Depuis 1886",
      learnMore: "En savoir plus",
    },
    header: {
      topbar: "CHAMBRE OFFICIELLE DE COMMERCE D'ESPAGNE À TANGER · DEPUIS 1886",
    },
    activityCategories: {
      all: "Toutes",
      proximas: "Prochaines activités",
      encuentros: "Rencontres d'entreprises",
      networking: "Networking",
      seminarios: "Séminaires",
      salones_ferias: "Salons, foires et forums",
      visitas_reuniones: "Visites et réunions",
      actos_institucionales: "Actes institutionnels",
      webinars: "Webinars",
    },
    home: {
      welcomeKicker: "Bienvenue à la CECIT",
      welcomeTitle: "Une institution centenaire au service du commerce bilatéral",
      welcomeBody: "La Chambre Officielle de Commerce d'Espagne à Tanger est, depuis 1886, un pont entre les économies espagnole et marocaine — en favorisant l'investissement, le commerce et la coopération entre les deux rives du Détroit.",
      manifestoKicker: "Depuis 1886",
      manifestoTitle: "Ensemble, nous créons l'avenir",
      manifestoBody: "Nous accompagnons les entreprises espagnoles et marocaines à chaque étape de leurs projets d'investissement et de commercialisation.",
      statsTitle: "Notre parcours en chiffres",
      stats: { years: "Années d'histoire", members: "Membres actifs", activities: "Activités organisées", companies: "Entreprises connectées" },
      servicesKicker: "Nos services",
      servicesTitle: "Des solutions intégrales pour votre entreprise",
      servicesBody: "Une proposition de valeur conçue pour accompagner les entreprises dans leur développement entre l'Espagne et le Maroc.",
      seeAll: "Voir tout",
      partnersTitle: "Nos membres",
      partnersSubtitle: "Entreprises qui font partie de notre réseau",
      benefitsKicker: "Avantages du membre",
      benefitsTitle: "Devenir membre de la CECIT",
      newsKicker: "Actualité",
      newsTitle: "Dernières actualités et événements",
      activitiesKicker: "Actualité",
      activitiesTitle: "Dernières activités",
      newsletterTitle: "Inscrivez-vous à notre Newsletter",
      newsletterBody: "Recevez chaque mois des informations sur les événements, opportunités d'affaires et nouveautés.",
      newsletterCta: "S'inscrire",
      newsletter: {
        namePlaceholder: "Nom (optionnel)",
        confirmSoon: "Presque fini — vérifiez votre courriel pour confirmer l'abonnement.",
        subscribed: "Merci ! Vous êtes inscrit.",
        pending: "Nous avons reçu votre courriel. Nous vous confirmerons bientôt.",
        failed: "Nous n'avons pas pu finaliser l'inscription.",
      },
      ctaJoinTitle: "Vous souhaitez rejoindre la CECIT ?",
      ctaJoinBody: "Accédez à un réseau privilégié d'entreprises espagnoles et marocaines.",
      ctaJoinBtn: "Devenir Membre",
      ctaDirTitle: "Annuaire des Membres",
      ctaDirBody: "Trouvez des entreprises, des secteurs et des contacts dans notre réseau.",
      ctaDirBtn: "Explorer l'annuaire",
    },
    services: {
      info: "Information Commerciale",
      infoDesc: "Études sectorielles et rapports de marché.",
      training: "Plateforme de Formation",
      trainingDesc: "Cours et développement professionnel.",
      visa: "Gestion des Visas",
      visaDesc: "Démarches professionnelles pour entreprises.",
      jobs: "Bourse de l'Emploi",
      jobsDesc: "Nous connectons talents et opportunités.",
      opportunities: "Opportunités d'Affaires",
      opportunitiesDesc: "Appels d'offres et alliances bilatérales.",
      arbitration: "Arbitrage et Médiation",
      arbitrationDesc: "Résolution de conflits commerciaux.",
      networking: "Networking",
      networkingDesc: "Événements exclusifs pour membres.",
      promotion: "Promotion Internationale",
      promotionDesc: "Visibilité en Espagne et au Maroc.",
    },
    benefits: {
      one: "Accès prioritaire aux événements et missions commerciales",
      two: "Informations de marché et études sectorielles",
      three: "Promotion de votre entreprise dans notre réseau",
      four: "Conseil institutionnel",
      five: "Tarifs réduits sur les services",
    },
    contact: {
      title: "Contact",
      subtitle: "Nous sommes à votre disposition",
      address: "Adresse",
      phone: "Téléphone",
      email: "Email",
      hours: "Horaires",
      formTitle: "Envoyez-nous un message",
      name: "Nom complet",
      company: "Entreprise",
      subject: "Sujet",
      message: "Message",
      consent: "J'ai lu et j'accepte la politique de confidentialité.",
      send: "Envoyer le message",
      sending: "Envoi...",
      success: "Message envoyé. Nous vous répondrons sous peu.",
      error: "Erreur lors de l'envoi du message.",
    },
    members: {
      title: "Annuaire des Membres",
      subtitle: "Trouvez des entreprises dans notre réseau",
      search: "Rechercher par nom ou secteur...",
      tier: "Catégorie",
      all: "Toutes",
      basico: "Basique",
      standard: "Standard",
      premium: "Premium",
      visit: "Visiter le site",
      noResults: "Aucun membre trouvé.",
    },
    footer: {
      partnersTitle: "AVEC LE SOUTIEN ET LA RECONNAISSANCE DE :",
      about: "Chambre Officielle de Commerce d'Espagne à Tanger. Au service des entreprises espagnoles et marocaines depuis 1886.",
      contact: "Contact",
      legal: "Légal",
      navigation: "Navigation",
      social: "Suivez-nous",
      rights: "Tous droits réservés.",
      poweredByPrefix: "Conçu et développé par",
      webAgencyTangier: "Agence Web à Tanger",
      privacy: "Politique de Confidentialité",
      cookies: "Politique de Cookies",
      legalNotice: "Mentions Légales",
      managePrefs: "Préférences des cookies",
    },
    cookies: {
      title: "Nous respectons votre vie privée",
      body: "Nous utilisons des cookies pour assurer le fonctionnement du site, mesurer son utilisation et vous offrir une meilleure expérience. Vous pouvez tout accepter, refuser les non essentiels ou les personnaliser.",
      acceptAll: "Tout accepter",
      rejectAll: "Refuser les non essentiels",
      customize: "Personnaliser",
      savePrefs: "Enregistrer les préférences",
      policyLink: "Voir la Politique de Cookies",
      catNecessary: "Nécessaires",
      catNecessaryDesc: "Indispensables au fonctionnement du site (session, sécurité, formulaires).",
      catAnalytics: "Analytiques",
      catAnalyticsDesc: "Nous permettent de mesurer l'utilisation du site de manière anonyme pour l'améliorer.",
      catMarketing: "Marketing",
      catMarketingDesc: "Utilisés pour afficher du contenu et des publicités pertinents.",
      catFunctional: "Fonctionnels",
      catFunctionalDesc: "Activent des fonctionnalités avancées comme les cartes ou vidéos intégrées.",
      alwaysOn: "Toujours activés",
    },
    common: {
      readMore: "Lire la suite",
      back: "Retour",
      loading: "Chargement...",
      sending: "Envoi…",
      filterAll: "Tous",
      upcoming: "Prochains",
      past: "Passés",
      noContent: "Aucun contenu disponible.",
    },
    cms: {
      login: "Se connecter",
      email: "Email",
      password: "Mot de passe",
      logout: "Se déconnecter",
      dashboard: "Tableau de bord",
      heroSlides: "Hero / Une",
      pages: "Pages",
      members: "Membres",
      news: "Actualités",
      events: "Événements",
      settings: "Paramètres",
      users: "Utilisateurs",
      submissions: "Messages",
      add: "Ajouter",
      edit: "Modifier",
      delete: "Supprimer",
      save: "Enregistrer",
      cancel: "Annuler",
      confirm: "Confirmer",
    },
  },
  en: {
    nav: {
      home: "Home", camara: "The Chamber", camaraOverview: "The Chamber", mision: "Mission & Goals",
      contacto: "Contact", servicios: "Services", informacion: "Information", anuario: "Yearbook",
      newsletters: "Newsletters", noticias: "Member News", invertir: "Invest in Morocco",
      actividades: "Activities", proximas: "Upcoming Activities", eventos: "Events", calendario: "Calendar",
      eventosCamara: "Chamber Events", eventosSocios: "Member Events", feriasEs: "Trade Fairs Spain",
      feriasMa: "Trade Fairs Morocco", socios: "Members", ventajas: "Membership Benefits",
      sociosStandard: "Standard Members", sociosPremium: "Premium Members", buscador: "Members Directory",
      becomeMember: "Become a Member", admin: "CMS",
    },
    hero: { since: "Since 1886", learnMore: "Learn more" },
    header: {
      topbar: "OFFICIAL SPANISH CHAMBER OF COMMERCE IN TANGIER · SINCE 1886",
    },
    activityCategories: {
      all: "All",
      proximas: "Upcoming activities",
      encuentros: "Business meetings",
      networking: "Networking",
      seminarios: "Seminars",
      salones_ferias: "Trade shows, fairs & forums",
      visitas_reuniones: "Visits & meetings",
      actos_institucionales: "Institutional events",
      webinars: "Webinars",
    },
    home: {
      welcomeKicker: "Welcome to CECIT",
      welcomeTitle: "A century-old institution serving bilateral trade",
      welcomeBody: "The Official Chamber of Commerce of Spain in Tangier has been, since 1886, a bridge between the Spanish and Moroccan economies — promoting investment, trade and cooperation between both sides of the Strait.",
      manifestoKicker: "Since 1886", manifestoTitle: "Together we build the future",
      manifestoBody: "We support Spanish and Moroccan companies at every stage of their investment and trade projects.",
      statsTitle: "Our track record in numbers",
      stats: { years: "Years of history", members: "Active members", activities: "Activities organised", companies: "Companies connected" },
      servicesKicker: "Our services", servicesTitle: "Comprehensive solutions for your company",
      servicesBody: "A value proposition designed to support companies growing between Spain and Morocco.",
      seeAll: "See all", partnersTitle: "Our members", partnersSubtitle: "Companies that are part of our network",
      benefitsKicker: "Membership benefits", benefitsTitle: "Become a CECIT member",
      newsKicker: "News", newsTitle: "Latest news and events",
      activitiesKicker: "News", activitiesTitle: "Latest activities",
      newsletterTitle: "Subscribe to our newsletter",
      newsletterBody: "Get monthly updates on events, business opportunities and news.",
      newsletterCta: "Subscribe",
      newsletter: {
        namePlaceholder: "Name (optional)",
        confirmSoon: "Almost done — check your email to confirm the subscription.",
        subscribed: "Thanks! You're now subscribed.",
        pending: "We've received your email. We'll confirm shortly.",
        failed: "We couldn't complete the subscription.",
      },
      ctaJoinTitle: "Would you like to join CECIT?",
      ctaJoinBody: "Access a privileged network of Spanish and Moroccan companies.",
      ctaJoinBtn: "Become a Member",
      ctaDirTitle: "Members Directory", ctaDirBody: "Find companies, sectors and contacts in our network.",
      ctaDirBtn: "Explore directory",
    },
    services: {
      info: "Business Intelligence", infoDesc: "Sector studies and market reports.",
      training: "Training Platform", trainingDesc: "Courses and professional development.",
      visa: "Visa Services", visaDesc: "Professional processing for companies.",
      jobs: "Job Board", jobsDesc: "Connecting talent with opportunities.",
      opportunities: "Business Opportunities", opportunitiesDesc: "Tenders and bilateral alliances.",
      arbitration: "Arbitration & Mediation", arbitrationDesc: "Commercial dispute resolution.",
      networking: "Networking", networkingDesc: "Exclusive events for members.",
      promotion: "International Promotion", promotionDesc: "Visibility across Spain and Morocco.",
    },
    benefits: {
      one: "Priority access to events and trade missions",
      two: "Market intelligence and sector studies",
      three: "Company promotion within our network",
      four: "Institutional advisory",
      five: "Reduced service fees",
    },
    contact: {
      title: "Contact", subtitle: "We are at your service", address: "Address", phone: "Phone",
      email: "Email", hours: "Opening hours", formTitle: "Send us a message",
      name: "Full name", company: "Company", subject: "Subject", message: "Message",
      consent: "I have read and accept the privacy policy.", send: "Send message", sending: "Sending...",
      success: "Message sent. We will reply shortly.", error: "Failed to send the message.",
    },
    members: {
      title: "Members Directory", subtitle: "Find companies in our network",
      search: "Search by name or sector...", tier: "Tier", all: "All",
      basico: "Basic", standard: "Standard", premium: "Premium",
      visit: "Visit website", noResults: "No members found.",
    },
    footer: {
      partnersTitle: "WITH THE SUPPORT AND RECOGNITION OF:",
      about: "Official Spanish Chamber of Commerce in Tangier. Serving Spanish and Moroccan companies since 1886.",
      contact: "Contact",
      legal: "Legal", navigation: "Navigation", social: "Follow us",
      rights: "All rights reserved.",
      poweredByPrefix: "Designed and powered by",
      webAgencyTangier: "Web Agency in Tangier",
      privacy: "Privacy Policy",
      cookies: "Cookie Policy", legalNotice: "Legal Notice", managePrefs: "Cookie preferences",
    },
    cookies: {
      title: "We respect your privacy",
      body: "We use cookies to keep the site running, measure its use and offer you a better experience. You can accept all, reject non-essential ones, or customise your choices.",
      acceptAll: "Accept all", rejectAll: "Reject non-essential", customize: "Customise",
      savePrefs: "Save preferences", policyLink: "See the Cookie Policy",
      catNecessary: "Necessary",
      catNecessaryDesc: "Essential for the site to function (session, security, forms).",
      catAnalytics: "Analytics",
      catAnalyticsDesc: "Let us measure site use anonymously to improve it.",
      catMarketing: "Marketing",
      catMarketingDesc: "Used to display relevant content and advertising.",
      catFunctional: "Functional",
      catFunctionalDesc: "Enable advanced features such as embedded maps or videos.",
      alwaysOn: "Always on",
    },
    common: { readMore: "Read more", back: "Back", loading: "Loading...", sending: "Sending…", filterAll: "All",
      upcoming: "Upcoming", past: "Past", noContent: "No content available." },
    cms: {
      login: "Log in", email: "Email", password: "Password", logout: "Log out",
      dashboard: "Dashboard", heroSlides: "Hero / Home", pages: "Pages", members: "Members",
      news: "News", events: "Events", settings: "Settings", users: "Users", submissions: "Messages",
      add: "Add", edit: "Edit", delete: "Delete", save: "Save", cancel: "Cancel", confirm: "Confirm",
    },
  },
  ar: {
    nav: {
      home: "الرئيسية", camara: "الغرفة", camaraOverview: "الغرفة", mision: "المهمة والأهداف",
      contacto: "اتصل بنا", servicios: "الخدمات", informacion: "معلومات", anuario: "الدليل السنوي",
      newsletters: "النشرات الإخبارية", noticias: "أخبار الأعضاء", invertir: "الاستثمار في المغرب",
      actividades: "الأنشطة", proximas: "الأنشطة القادمة", eventos: "الفعاليات", calendario: "التقويم",
      eventosCamara: "فعاليات الغرفة", eventosSocios: "فعاليات الأعضاء",
      feriasEs: "معارض إسبانيا", feriasMa: "معارض المغرب",
      socios: "الأعضاء", ventajas: "مزايا العضوية", sociosStandard: "الأعضاء العاديون",
      sociosPremium: "الأعضاء المميزون", buscador: "دليل الأعضاء", becomeMember: "انضم إلينا", admin: "لوحة التحكم",
    },
    hero: { since: "منذ 1886", learnMore: "اعرف المزيد" },
    header: {
      topbar: "الغرفة الرسمية للتجارة الإسبانية في طنجة · منذ 1886",
    },
    activityCategories: {
      all: "الكل",
      proximas: "الأنشطة القادمة",
      encuentros: "لقاءات الأعمال",
      networking: "التشبيك",
      seminarios: "ندوات",
      salones_ferias: "المعارض والصالونات والمنتديات",
      visitas_reuniones: "الزيارات والاجتماعات",
      actos_institucionales: "فعاليات مؤسسية",
      webinars: "ندوات عبر الإنترنت",
    },
    home: {
      welcomeKicker: "مرحبًا بكم في CECIT",
      welcomeTitle: "مؤسسة عريقة في خدمة التجارة الثنائية",
      welcomeBody: "منذ عام 1886، تشكّل غرفة التجارة الرسمية لإسبانيا في طنجة جسرًا بين الاقتصادين الإسباني والمغربي، وتعمل على تعزيز الاستثمار والتجارة والتعاون بين ضفتي المضيق.",
      manifestoKicker: "منذ 1886", manifestoTitle: "معًا نصنع المستقبل",
      manifestoBody: "نرافق الشركات الإسبانية والمغربية في كل مراحل مشاريعها الاستثمارية والتجارية.",
      statsTitle: "مسيرتنا بالأرقام",
      stats: { years: "سنوات من التاريخ", members: "أعضاء ناشطون", activities: "أنشطة منظمة", companies: "شركات مرتبطة" },
      servicesKicker: "خدماتنا", servicesTitle: "حلول متكاملة لشركتكم",
      servicesBody: "عرض قيمة مصمَّم لمرافقة الشركات في تطوّرها بين إسبانيا والمغرب.",
      seeAll: "عرض الكل", partnersTitle: "أعضاؤنا", partnersSubtitle: "الشركات المنضوية تحت شبكتنا",
      benefitsKicker: "مزايا العضوية", benefitsTitle: "كن عضوًا في CECIT",
      newsKicker: "أخبار", newsTitle: "آخر الأخبار والفعاليات",
      activitiesKicker: "أخبار", activitiesTitle: "آخر الأنشطة",
      newsletterTitle: "اشترك في نشرتنا الإخبارية",
      newsletterBody: "استلم شهريًا معلومات عن الفعاليات وفرص الأعمال والمستجدات.",
      newsletterCta: "اشترك",
      newsletter: {
        namePlaceholder: "الاسم (اختياري)",
        confirmSoon: "بقيت خطوة أخيرة — تحقّق من بريدك لتأكيد الاشتراك.",
        subscribed: "شكرًا لك! تم تسجيل اشتراكك.",
        pending: "استلمنا بريدك، وسنؤكّد ذلك قريبًا.",
        failed: "تعذّر إتمام الاشتراك.",
      },
      ctaJoinTitle: "هل ترغب في الانضمام إلى CECIT؟",
      ctaJoinBody: "انضم إلى شبكة مميزة من الشركات الإسبانية والمغربية.",
      ctaJoinBtn: "انضم إلينا",
      ctaDirTitle: "دليل الأعضاء", ctaDirBody: "ابحث عن الشركات والقطاعات وجهات الاتصال في شبكتنا.",
      ctaDirBtn: "استكشاف الدليل",
    },
    services: {
      info: "معلومات الأعمال", infoDesc: "دراسات قطاعية وتقارير سوقية.",
      training: "منصة التكوين", trainingDesc: "دورات وتطوير مهني.",
      visa: "إدارة التأشيرات", visaDesc: "معالجة احترافية للشركات.",
      jobs: "بوابة التوظيف", jobsDesc: "نربط الكفاءات بالفرص.",
      opportunities: "فرص الأعمال", opportunitiesDesc: "طلبات عروض وشراكات ثنائية.",
      arbitration: "التحكيم والوساطة", arbitrationDesc: "حلّ النزاعات التجارية.",
      networking: "التشبيك", networkingDesc: "فعاليات حصرية للأعضاء.",
      promotion: "الترويج الدولي", promotionDesc: "حضور في إسبانيا والمغرب.",
    },
    benefits: {
      one: "أولوية الوصول إلى الفعاليات والبعثات التجارية",
      two: "معلومات السوق ودراسات قطاعية",
      three: "الترويج لشركتكم داخل شبكتنا",
      four: "استشارات مؤسسية",
      five: "تعرفات مخفَّضة على الخدمات",
    },
    contact: {
      title: "اتصل بنا", subtitle: "نحن رهن إشارتكم", address: "العنوان", phone: "الهاتف",
      email: "البريد الإلكتروني", hours: "ساعات العمل", formTitle: "أرسل لنا رسالة",
      name: "الاسم الكامل", company: "الشركة", subject: "الموضوع", message: "الرسالة",
      consent: "قرأتُ سياسة الخصوصية وأوافق عليها.", send: "إرسال الرسالة", sending: "جارٍ الإرسال...",
      success: "تم إرسال الرسالة، سنتواصل معكم قريبًا.", error: "تعذّر إرسال الرسالة.",
    },
    members: {
      title: "دليل الأعضاء", subtitle: "ابحث عن الشركات في شبكتنا",
      search: "ابحث بالاسم أو القطاع...", tier: "الفئة", all: "الكل",
      basico: "أساسي", standard: "قياسي", premium: "مميّز",
      visit: "زيارة الموقع", noResults: "لم يتم العثور على أعضاء.",
    },
    footer: {
      partnersTitle: "بدعم واعتراف من:",
      about: "الغرفة الرسمية للتجارة الإسبانية في طنجة. في خدمة الشركات الإسبانية والمغربية منذ عام 1886.",
      contact: "اتصل بنا", legal: "قانوني",
      navigation: "التصفح", social: "تابعنا", rights: "جميع الحقوق محفوظة.",
      poweredByPrefix: "تصميم وتطوير",
      webAgencyTangier: "وكالة ويب في طنجة",
      privacy: "سياسة الخصوصية", cookies: "سياسة ملفات تعريف الارتباط",
      legalNotice: "الإشعار القانوني", managePrefs: "تفضيلات ملفات تعريف الارتباط",
    },
    cookies: {
      title: "نحترم خصوصيتكم",
      body: "نستخدم ملفات تعريف الارتباط لضمان عمل الموقع وقياس استخدامه وتحسين تجربتكم. يمكنكم القبول الكامل أو رفض غير الضروري منها أو تخصيصها.",
      acceptAll: "قبول الكل", rejectAll: "رفض غير الضروري", customize: "تخصيص",
      savePrefs: "حفظ التفضيلات", policyLink: "الاطلاع على سياسة الكوكيز",
      catNecessary: "ضرورية", catNecessaryDesc: "أساسية لعمل الموقع (الجلسة، الأمان، النماذج).",
      catAnalytics: "تحليلية", catAnalyticsDesc: "تسمح بقياس الاستخدام مجهول الهوية لتحسين الموقع.",
      catMarketing: "تسويقية", catMarketingDesc: "لعرض محتوى وإعلانات ذات صلة.",
      catFunctional: "وظيفية", catFunctionalDesc: "لتفعيل ميزات متقدمة كالخرائط والفيديوهات المدمجة.",
      alwaysOn: "دائمًا نشطة",
    },
    common: { readMore: "اقرأ المزيد", back: "رجوع", loading: "جارٍ التحميل...", sending: "جارٍ الإرسال…", filterAll: "الكل",
      upcoming: "القادمة", past: "السابقة", noContent: "لا يوجد محتوى متاح." },
    cms: {
      login: "تسجيل الدخول", email: "البريد الإلكتروني", password: "كلمة المرور",
      logout: "تسجيل الخروج", dashboard: "لوحة التحكم", heroSlides: "الواجهة الرئيسية",
      pages: "الصفحات", members: "الأعضاء", news: "الأخبار", events: "الفعاليات",
      settings: "الإعدادات", users: "المستخدمون", submissions: "الرسائل",
      add: "إضافة", edit: "تعديل", delete: "حذف", save: "حفظ", cancel: "إلغاء", confirm: "تأكيد",
    },
  },
};

// Supported languages. Spanish is the primary/default; the others fall back
// to Spanish when a translation key is missing. Arabic is right-to-left.
export const LANGUAGES = [
  { code: "es", label: "Español",  short: "ES", dir: "ltr" },
  { code: "fr", label: "Français", short: "FR", dir: "ltr" },
  { code: "en", label: "English",  short: "EN", dir: "ltr" },
  { code: "ar", label: "العربية",  short: "AR", dir: "rtl" },
];

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const stored = localStorage.getItem("cecit_lang");
    return LANGUAGES.some((l) => l.code === stored) ? stored : "es";
  });

  useEffect(() => {
    localStorage.setItem("cecit_lang", lang);
    document.documentElement.lang = lang;
    const meta = LANGUAGES.find((l) => l.code === lang);
    document.documentElement.dir = meta?.dir || "ltr";
  }, [lang]);

  const t = useCallback((path) => {
    const segs = path.split(".");
    const walk = (root) => {
      let cur = root;
      for (const s of segs) {
        if (cur == null) return undefined;
        cur = cur[s];
      }
      return cur;
    };
    return walk(TRANSLATIONS[lang]) ?? walk(TRANSLATIONS.es) ?? path;
  }, [lang]);

  // For CMS-managed fields (_es, _fr, _en, _ar). Falls back to Spanish so any
  // record that has not been translated yet still renders instead of being blank.
  const pick = useCallback((obj, key) => {
    if (!obj) return "";
    return obj[`${key}_${lang}`] || obj[`${key}_es`] || obj[`${key}_fr`] || obj[`${key}_en`] || "";
  }, [lang]);

  // Stable context value — without useMemo, every provider render creates a
  // fresh object and forces ALL consumers to re-render (this provider sits
  // at the app root so that's the whole tree). setLang/t/pick are already
  // stable references from useState/useCallback.
  const value = useMemo(
    () => ({ lang, setLang, t, pick, languages: LANGUAGES }),
    [lang, t, pick],
  );

  return (
    <LangContext.Provider value={value}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
}
